<template>
    <div>
        <v-card class="rounded-lg" @click="handleCardClick(card)">
            <v-container fluid>
                <v-row no-gutters>
                    <v-col cols="auto">
                        <v-auto-img
                            v-if="image"
                            :src="image"
                            alt="Trainingcard Image"
                            class="rounded-lg"
                            style="width: 6.5rem; height: 6.5rem; object-fit: cover;"
                        >
                        </v-auto-img>
                        <div v-else class="placeholder rounded-lg">
                             <v-icon
                                color="grey lighten-1"
                                style="font-size: 6.5rem;"
                            >
                                mdi-image-off
                            </v-icon>
                        </div>
                    </v-col>
                    <v-col>
                        <div class="d-flex flex-column justify-space-between pl-2 text-body-2">
                            <div class="mt-auto text-body-2">
                                <div class="d-flex justify-space-between align-items-center">
                                     <strong>{{card.cardtype_name}} </strong>
                                    <v-btn icon small>
                                        <v-icon color="info" @click="showingCard = card" >mdi-information-outline</v-icon>
                                    </v-btn>
                                </div>

                                <div v-if="card.user_id != $store.state.user.id && managedUserForCard" class="d-flex">
                                    <UserAvatar :user="managedUserForCard" :size="32" />
                                    <div class="ml-2">{{$translate('The card belongs to')}} {{ managedUserForCard.name }}</div>
                                </div>

                                <div v-if="userGroupsForCard.length > 0">
                                    <div>
                                        <span>{{$translate('Group card, can be used by all members of')}} {{ formatedGroupNames }}</span>
                                        <span v-if="card.user_id == $store.state.user.id"> ({{$translate('You are a cardholder')}})</span>
                                    </div>
                                </div>

                                <div v-if="isExpiring && !card.membership">
                                    <v-icon small class="error--text">mdi-alert</v-icon>
                                    <span class="error--text"> {{$translate('The card is terminated')}}</span>
                                </div>

                                <div v-if="card.trainingsLeft || (card.trainingsLeft != null && card.boundToDate)">
                                    <v-icon small>mdi-ticket</v-icon> {{card.trainingsLeft}} {{$translate('trainings left')}}
                                </div>

                                <div v-if="card.validFromDate && Date.newFull(card.validFromDate).isFutureDate()">
                                    <v-icon small>mdi-calendar-clock</v-icon>
                                    <span> {{$translate('Valid from')}} {{Date.formatFullShort(card.validFromDate) + ' ' + Date.newFull(card.validFromDate).getFullYear()}}</span>
                                </div>

                                <div v-if="card.validToDate && !isExpiring">
                                    <v-icon small>mdi-calendar-clock</v-icon>
                                    <span> {{$translate('Valid until')}} {{Date.formatFullShort(card.validToDate) + ' ' + Date.newFull(card.validToDate).getFullYear()}}</span>
                                </div>
                                <div v-else-if="isExpiring && !card.membership">
                                    <v-icon small class="error--text">mdi-calendar-clock</v-icon>
                                    <span class="error--text"> {{$translate('Valid until')}} {{Date.formatFullShort(card.validToDate) + ' ' + Date.newFull(card.validToDate).getFullYear()}}</span>
                                </div>
                                <div v-else>
                                    <v-icon small>mdi-update</v-icon>
                                    <span>{{$translate('Recurring, automatically extended')}}</span>
                                </div>

                                <div v-if="card.boundToDate && Date.newFull(card.boundToDate).isFuture()">
                                    <div>
                                        <v-icon small>mdi-calendar-clock</v-icon>
                                        <span> {{$translate('Bound until')}} {{Date.formatFullShort(card.boundToDate) + ' ' + Date.newFull(card.boundToDate).getFullYear()}}</span>
                                    </div>
                                    <div>
                                        <v-icon small>mdi-wallet</v-icon>
                                        <span class="ml-1">{{ paidUntilDateForCard }}</span>
                                    </div>
                                </div>

                                <div v-if="activeFreeze">
                                    <span class="error--text">{{ activeFreezeText }}</span>
                                </div>

                                <div v-if="comingFreeze">
                                    <v-icon small color="info">mdi-snowflake</v-icon>
                                    <span class="ml-1 info--text">{{ comingFreezeText }}</span>
                                </div>
                            </div>
                            </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <training-card-dialog v-model="showTrainingCardDialog" :card="showingCard" v-if="showTrainingCardDialog" />
    </div>
</template>

<script>
import UserAvatar from './UserAvatar.vue';
import TrainingCardDialog from './TrainingCardDialog.vue';

export default {
    name: 'training-card-and-membership-card',

    props: {
        card: {
            type: Object,
            required: true
        }
    },

    components: {
        UserAvatar,
        TrainingCardDialog
    },

    data: () => ({
        showingCard: null,
        showTrainingCardDialog: false,
    }),

    computed: {
        image() {
            return this.card.cardtype.imagekey
        },
        activeFreeze() {
            return this.$booking.getActiveFreeze(this.card, this.$store.state.now30s.clone());
        },
        comingFreeze() {
            return this.$booking.getComingFreeze(this.card);
        },
        isExpiring() {
            return this.card.validToDate && this.card.cardtype.auto;
        },
        paidUntilDateForCard() {
            const paidPayments = this.card.payments.filter(p => p.status == 'paid').sort((a,b) => Date.newFull(a.to_date).getTime() - Date.newFull(b.to_date).getTime());
            if (paidPayments.length == 0) {
                return this.$translate('No payments have been made');
            } else {
                const paidUntilDate = paidPayments[paidPayments.length - 1].to_date;
                return  `${this.$translate('Paid until')} ${Date.formatFullShort(paidUntilDate)} ${Date.newFull(paidUntilDate).getFullYear()}`
            }
        },
        userGroupsForCard() {
            return this.$store.state?.user?.groups?.filter(x => x.show && x.trainingcards?.includes(this.card.id));
        },
        managedUserForCard() {
            return this.$store.state?.user?.canManage?.find(x => x.id == this.card.user_id);
        },
        formatedGroupNames() {
            return this.userGroupsForCard.map(g => g.name).join(', ');
        },
        comingFreezeText() {
            const freeze = this.comingFreeze;
            if (freeze) {
                return this.$translate('The card will be frozen from {0} to {1}').format(
                    Date.formatFullShort(freeze.fromDate) + ' ' + Date.newFull(freeze.fromDate).getFullYear(),
                    Date.formatFullShort(freeze.toDate) + ' ' + Date.newFull(freeze.toDate).getFullYear()
                );
            }
            return '';
        },
        activeFreezeText() {
            const freeze = this.activeFreeze;
            if (freeze) {
                return this.$translate('The card is frozen until {0}').format(
                    Date.formatFullShort(freeze.toDate) + ' ' + Date.newFull(freeze.toDate).getFullYear()
                );
            }
            return '';
        },
    },

    watch: {
        '$store.state.cards'(cards) {
            if (this.showingCard) {
                this.showingCard = cards.find(x => x.id == this.showingCard.id);
                if (!this.showingCard) {
                    this.showTrainingCardDialog = false;
                }
            }
        },
    },

    methods: {
        handleCardClick(card) {
            if (!card.chain) {
                this.showingCard = card;
                this.showTrainingCardDialog = true;
            }
        },
    }
}
</script>
